import { Loader2 } from 'lucide-react';
import i18n from '../../i18n/index.js';

export const LoadingScreen = ({ label }) => (
  <div className="grid min-h-[50vh] place-items-center bg-beam-light text-beam-ink">
    <div className="flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.25em] text-beam-blue">
      <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />
      <span>{label || i18n.t('common.loading')}</span>
    </div>
  </div>
);
